import { SaveScope, SaveButton } from "@/components/SaveForm";
import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { CleanupAdmin } from "@/components/CleanupAdmin";
import { Settings as SettingsIcon, Calculator, Plug, ShieldCheck } from "lucide-react";

const inp = "bg-slate-950 border-slate-700 text-slate-100 mt-1 font-mono";

export default function Settings() {
  const { can } = useAuth();
  const [cfg, setCfg] = useState(null);

  useEffect(() => { api.get("/config").then((r) => setCfg(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/config", {
        periodo_analise_dias: Number(cfg.periodo_analise_dias),
        fator_excesso: Number(cfg.fator_excesso),
        multiplicador_critico: Number(cfg.multiplicador_critico),
      });
      toast.success("Configurações do motor atualizadas.");
    } catch (e) { toast.error(apiErr(e)); }
  };

  if (!cfg) return <Skeleton className="h-96 bg-slate-800" />;
  const editable = can();

  return (
    <div className="space-y-6 max-w-3xl">
      <div><h1 className="font-display text-3xl font-bold text-slate-50 flex items-center gap-2"><SettingsIcon className="h-7 w-7" /> Configurações</h1><p className="text-slate-400 text-sm">Parâmetros do motor inteligente de reposição e integrações futuras.</p></div>

      <SaveScope blocked={!editable}><Card className="card-metal p-6">
        <div className="flex items-center gap-2 mb-4"><Calculator className="h-5 w-5 text-sky-400" /><h2 className="font-display text-xl font-semibold text-slate-100">Motor de Reposição</h2></div>
        <div className="grid sm:grid-cols-3 gap-4">
          <div><Label>Período de análise (dias)</Label><Input type="number" className={inp} value={cfg.periodo_analise_dias} disabled={!editable} onChange={(e) => setCfg({ ...cfg, periodo_analise_dias: e.target.value })} /><p className="text-xs text-slate-500 mt-1">Janela de consumo histórico.</p></div>
          <div><Label>Fator de excesso</Label><Input type="number" step="0.1" className={inp} value={cfg.fator_excesso} disabled={!editable} onChange={(e) => setCfg({ ...cfg, fator_excesso: e.target.value })} /><p className="text-xs text-slate-500 mt-1">Acima de ideal × fator = excesso.</p></div>
          <div><Label>Multiplicador crítico</Label><Input type="number" step="0.1" className={inp} value={cfg.multiplicador_critico} disabled={!editable} onChange={(e) => setCfg({ ...cfg, multiplicador_critico: e.target.value })} /><p className="text-xs text-slate-500 mt-1">Folga extra para peças críticas.</p></div>
        </div>
        <div className="mt-4 rounded-lg bg-slate-950/60 border border-slate-800 p-4 text-xs text-slate-400 font-mono space-y-1">
          <div>consumo_médio_diário = total_consumido / período_análise</div>
          <div>demanda_lead_time = consumo_médio_diário × lead_time</div>
          <div>ponto_reposição = demanda_lead_time + estoque_segurança</div>
          <div>quantidade_sugerida = teto(estoque_ideal_projetado − estoque_atual)</div>
        </div>
        {editable && <SaveButton data-testid="btn-save-config" onClick={save} className="mt-4 bg-sky-700 hover:bg-sky-600">Salvar parâmetros</SaveButton>}
      </Card></SaveScope>

      <Card className="card-metal p-6">
        <div className="flex items-center gap-2 mb-3"><Plug className="h-5 w-5 text-slate-400" /><h2 className="font-display text-xl font-semibold text-slate-100">Integrações futuras (preparado)</h2></div>
        <div className="space-y-2 text-sm text-slate-400">
          <div className="flex items-center justify-between rounded-lg bg-slate-950/40 px-4 py-3"><span>ERP Omie (produtos, estoque, movimentações, compras)</span><span className="text-xs rounded bg-slate-800 px-2 py-0.5 text-slate-400">Não conectado</span></div>
          <div className="flex items-center justify-between rounded-lg bg-slate-950/40 px-4 py-3"><span>Sistema de Manutenção (movimentações automáticas)</span><span className="text-xs rounded bg-slate-800 px-2 py-0.5 text-slate-400">Preparado</span></div>
          <div className="flex items-center justify-between rounded-lg bg-slate-950/40 px-4 py-3"><span>Notificações externas (WhatsApp / E-mail / Push)</span><span className="text-xs rounded bg-slate-800 px-2 py-0.5 text-slate-400">Preparado</span></div>
        </div>
        <p className="mt-3 text-xs text-slate-500 flex items-center gap-1"><ShieldCheck className="h-3.5 w-3.5 text-emerald-500" /> Arquitetura desacoplada — nenhuma credencial externa armazenada nesta versão.</p>
      </Card>

      {editable && <CleanupAdmin />}
    </div>
  );
}
